var _defs, _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _rect4, _rect5, _path5, _path6, _path7, _g, _path8, _circle, _path9, _path10, _path11, _circle2, _circle3, _circle4, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "6.445 5 387.173 189.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4,.cls-7{fill:#8a96a3}.cls-1{opacity:.1}.cls-2{fill:#fff}.cls-3{opacity:.6}.cls-4{opacity:.25}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120.2,
    height: 110.8,
    x: 19.7,
    y: 68.6,
    className: "cls-1",
    rx: 4.2,
    transform: "rotate(-16.5 79.9 124)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 80.3h99.3v78.4H28.8z",
    className: "cls-2",
    transform: "rotate(-16.3 80 121.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3 102.3h34.5v34.5H61.3z",
    className: "cls-3",
    transform: "rotate(-16.5 78.5 119.6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 110,
    x: 148,
    y: 72,
    className: "cls-1",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 106.2,
    height: 115.3,
    x: 269.6,
    y: 62.5,
    className: "cls-1",
    rx: 4,
    transform: "rotate(-72.8 322.7 120)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.7 68.2h75v95h-75z",
    className: "cls-2",
    transform: "rotate(-72.8 324.2 115.7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m340.6 140.1-43.7-13.5 33.9-32.1 9.8 45.6z",
    className: "cls-3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 138,
    x: 133,
    y: 24,
    className: "cls-2",
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 138,
    x: 133,
    y: 24,
    className: "cls-4",
    rx: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133 91.8V158a4 4 0 0 0 4 4h9.8l2.4-.7a4.2 4.2 0 0 0 2.8-5.2z",
    className: "cls-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    d: "M149.8 152.2a.6.6 0 0 1-.4-.2c-3.4-3.4-6-5.5-6-8a3.7 3.7 0 0 1 3.7-3.9 3.6 3.6 0 0 1 2.7 1.4 3.6 3.6 0 0 1 2.7-1.4 3.8 3.8 0 0 1 3.7 3.8c0 2.6-2.4 4.6-6 8.1a.6.6 0 0 1-.4.2z",
    className: "cls-4",
    "data-name": "Path 903"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a96a3",
    d: "M147.3 140.1h-.2a3.7 3.7 0 0 0-3.6 3.8c0 2.6 2.5 4.7 5.9 8.1a.7.7 0 0 0 .9 0l.4-.4z",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M166.3 152.5a.6.6 0 0 1-.6-.6v-1.3a5.4 5.4 0 1 1 6-5.4c0 4.5-4.7 7.3-5.4 7.3z",
    className: "cls-7",
    "data-name": "Path 38"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145 46h96v84h-96z",
    className: "cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 90,
    r: 20,
    className: "cls-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133 5h4v11h-4z",
    className: "cls-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114 24h11v4h-11z",
    className: "cls-7",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M181.5 142.9H241m-59.5 8h15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 35,
    r: 3,
    className: "cls-2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 35,
    r: 3,
    className: "cls-2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 35,
    r: 3,
    className: "cls-2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m241 62.6-41.8 42.1-13.7-14.6L145 130h96V62.6z",
    className: "cls-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m199.9 104.4.5-.5zM186 90l-14.2 14a20 20 0 0 0 27.8.6z",
    className: "cls-4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 8.7h4v11.1h-4z",
    className: "cls-1",
    transform: "rotate(-45 123.5 14.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFeed);
export default __webpack_public_path__ + "static/media/empty-feed.d8469c06f5d3c6a2208810eb352d6597.svg";
export { ForwardRef as ReactComponent };